// extracted by mini-css-extract-plugin
var _1 = "TiersComparisonTableStyles-module__arrowFlip___DR0cl";
var _2 = "TiersComparisonTableStyles-module__compareTiersBtnBox___O9je1";
var _3 = "TiersComparisonTableStyles-module__comparisonTable___bUAuy";
var _4 = "TiersComparisonTableStyles-module__rowDark___D3xhZ";
var _5 = "TiersComparisonTableStyles-module__rowLight___o8Qxn";
var _6 = "TiersComparisonTableStyles-module__soonBadge___MnZSh";
var _7 = "TiersComparisonTableStyles-module__table___jPvwg";
var _8 = "TiersComparisonTableStyles-module__tierBox___Ar46W";
var _9 = "TiersComparisonTableStyles-module__tiersContainer___RyrcU";
export { _1 as "arrowFlip", _2 as "compareTiersBtnBox", _3 as "comparisonTable", _4 as "rowDark", _5 as "rowLight", _6 as "soonBadge", _7 as "table", _8 as "tierBox", _9 as "tiersContainer" }
